export default ".main {\n  height: 500px;\n  width: 750px;\n  display: flex;\n  --cropper-overlay-color: rgba(0, 0, 0, 0);\n}";